import angular from 'angular';
import { LoadParams } from '../../shared/models/loadparams.model';
import { ITrabalhadorLocado } from './models/trabalhadorlocado.model';
import { ITrabalhadoresLocados } from './models/trabalhadoreslocados.model';

export class TrabalhadoresLocadosService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q', '$filter'];

    public entities: Array<ITrabalhadoresLocados> = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: LoadParams;
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService,
        public $filter: any,
    ) {
        this.loadParams = new LoadParams();
    }

    reload(to_load: number = 3) {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.filters = {};
        this.loadParams.finished = false;
        this.loadParams.to_load = to_load;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter?: any) {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;

            Object.keys(this.filters).forEach((k): void => {
                delete this.filters[k];
            });

            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');

                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        /* Solução temporária para contornar o problema do mda-ui-select*/
        if (constructors.status) {
            if (constructors.status.toString().length === 1) {
                constructors.status = '0' + constructors.status;
            }
        }

        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('persona_locados_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
                .then((response: any) => {

                    resolve(response.data);

                })
                .catch((response: any) => {
                    reject(response);
                });
        });

    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any): void => {
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }

                        this.after['nome'] = this.entities[this.entities.length - 1]['nome'];
                        this.after['locado'] = this.entities[this.entities.length - 1]['locado'];
                    }
                    if (data.length < 50) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('persona_locados_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;

                    if (this.loadParams.to_load === 0 || data.length <= 50) {
                        this.$rootScope.$broadcast('persona_locados_list_loaded', this.entities);
                    }
                })
                .catch((error: any): void => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally((): void => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 3;
        this.load();
    }

    find(identifier: string): ITrabalhadoresLocados | null {
        for (var i in this.entities) {
            if (this.entities[i]['locado'] === identifier) {
                return this.entities[i];
            }
        }

        return null;
    }

    get(identifier: string): any {
        this.loading_deferred = this.$q.defer();
        this.loadParams.busy = true;

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http
                .get(
                    this.nsjRouting.generate('persona_locados_get', { 'id': identifier }, true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response: any): void => {
                    this.$rootScope.$broadcast('persona_locados_loaded', response.data);
                    this.loadParams.busy = false;
                    resolve(response.data);
                })
                .catch((response: any): void => {
                    this.loadParams.busy = false;
                    reject(response);
                });
        });
    }

}
